import { createContext, useContext, useState, useEffect, useMemo } from "react";
import { translations } from "./translations";
import { relaunch } from "./relaunch";
import { relaunchStock } from "./relaunchStock";
import { relaunchSell } from "./relaunchSell";
import { localeFromPath } from "./localePath";
import { useVersion } from "../version/VersionContext";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localeFromPath(window.location.pathname));

    useEffect(() => {
        try { localStorage.setItem("parto-lang", lang); } catch (e) { /* Speicher gesperrt, Sprache kommt aus der URL */ }
        document.documentElement.lang = lang;
    }, [lang]);

    // Version 4 (30.10.2026): Inhalte bleiben in der deutschen Quelle (lang "de"), die englische Fassung entsteht
    // über die Übersetzungsebene src/v4/i18n. uiLang ist die Sprache der Adresse (Links, Sprachwahl, Meta).
    const { version } = useVersion();
    const content = version === "4" && lang === "en" ? "de" : lang;
    const t = useMemo(() => ({ ...translations[content], r: { ...relaunch[content], stockPages: relaunchStock[content], sell: relaunchSell[content] } }), [content]);

    return (
        <LanguageContext.Provider value={{ lang: content, uiLang: lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
